import { gql } from "@apollo/client";

export const ARTICLES_INDEX = gql`
  query(
    $pageSize: Int
    $offset: Int
    $filter: ArticleFilter
    $sorting: [ArticleSort!]
  ) {
    articles(
      paging: { limit: $pageSize, offset: $offset }
      sorting: $sorting
      filter: $filter
    ) {
      totalCount
      nodes {
        id
        name
        project {
          id
          name
        }
        language
        createdAt
        createdBy {
          id
          firstName
          lastName
          email
        }
        updatedAt
        updatedBy {
          id
          firstName
          lastName
          email
        }
        isVisible
        slug
        author {
          name
          user {
            id
            firstName
            lastName
            email
          }
        }
      }
    }
  }
`;

export const ARTICLES_SHOW = gql`
  query ArticleShow($id: Int!) {
    article(id: $id) {
      id
      name
      slug
      lead
      content
      isVisible
      createdAt
      readTime
      imageUrl
      project {
        id
        name
      }
      language
      createdBy {
        id
        firstName
        lastName
      }
      updatedAt
      updatedBy {
        id
        firstName
        lastName
      }
      tags {
        id
        name
      }
      categories {
        id
        name
      }
      seoTagset {
        id
        metaTitle
        metaDescription
        metaKeywords
        ogTitle
        ogDescription
        canonical
        robots
      }
      author {
        name
        user {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;

export const ARTICLES_SELECT = gql`
  query($filter: ArticleFilter) {
    articles(paging: { limit: 10000 }, filter: $filter) {
      nodes {
        id
        name
      }
    }
  }
`;

export const ARTICLES_CREATE = gql`
  mutation ArticleCreate(
    $articleCreateInput: ArticleCreateInput!
    $authorAssignInput: AuthorAssignInput!
    $seoTagsetUpsertInput: SeoTagsetUpsertInput
  ) {
    articleCreate(
      articleCreateInput: $articleCreateInput
      authorAssignInput: $authorAssignInput
      seoTagsetUpsertInput: $seoTagsetUpsertInput
    ) {
      id
    }
  }
`;

export const ARTICLES_UPDATE = gql`
  mutation ArticleUpdate(
    $articleUpdateInput: ArticleUpdateInput!
    $authorAssignInput: AuthorAssignInput
    $seoTagsetUpsertInput: SeoTagsetUpsertInput
  ) {
    articleUpdate(
      articleUpdateInput: $articleUpdateInput
      authorAssignInput: $authorAssignInput
      seoTagsetUpsertInput: $seoTagsetUpsertInput
    ) {
      id
    }
  }
`;

export const ARTICLES_DELETE = gql`
  mutation ArticleDelete($articleDeleteInput: ArticleDeleteInput!) {
    articleDelete(articleDeleteInput: $articleDeleteInput) {
      id
    }
  }
`;
